/**
 * @flow
 * @relayHash 24f9c2b4e9679dcd0b4b0b77c35f6cb5
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type PaginatedInvoicesContainer_invoices$ref = any;
export type InvoiceSortField = "AMOUNT_DUE" | "CREATED_AT" | "CUSTOMER" | "DUE_DATE" | "INVOICE_NUMBER" | "ISSUE_DATE" | "ORDER_NUMBER" | "STATUS" | "TOTAL_AMOUNT" | "UPDATED_AT";
export type InvoiceStatus = "DRAFT" | "OVERDUE" | "PAID" | "PARTIALLY_PAID" | "SENT" | "VOID";
export type Permission = "CREATE_API_KEY" | "CREATE_CUSTOMER" | "CREATE_INVOICE" | "CREATE_ITEM" | "CREATE_JOB" | "CREATE_LOT" | "CREATE_ORDER" | "CREATE_PAYMENT" | "CREATE_SHIPMENT" | "DELETE_API_KEY" | "DELETE_CUSTOMER" | "DELETE_INVOICE" | "DELETE_ITEM" | "DELETE_JOB" | "DELETE_LOT" | "DELETE_ORDER" | "DELETE_SHIPMENT" | "READ_API_KEY" | "READ_CUSTOMER" | "READ_INVOICE" | "READ_ITEM" | "READ_JOB" | "READ_LOT" | "READ_ORDER" | "READ_PAYMENT" | "READ_SHIPMENT" | "UPDATE_API_KEY" | "UPDATE_CUSTOMER" | "UPDATE_INVOICE" | "UPDATE_ITEM" | "UPDATE_JOB" | "UPDATE_LOT" | "UPDATE_ORDER" | "UPDATE_SHIPMENT";
export type SortDirection = "ASC" | "DESC";
export type InvoiceSort = {|
  field: InvoiceSortField,
  direction: SortDirection,
|};
export type InvoicesQueryVariables = {|
  count: number,
  cursor?: ?string,
  search?: ?string,
  sortBy?: ?InvoiceSort,
  statuses?: ?$ReadOnlyArray<InvoiceStatus>,
  customerIds?: ?$ReadOnlyArray<string>,
  orderIds?: ?$ReadOnlyArray<string>,
  issueDateStart?: ?any,
  issueDateEnd?: ?any,
  dueDateStart?: ?any,
  dueDateEnd?: ?any,
|};
export type InvoicesQueryResponse = {|
  +viewer: ?{|
    +id: string,
    +permissions: $ReadOnlyArray<Permission>,
    +company: {|
      +id: string
    |},
  |},
  +$fragmentRefs: PaginatedInvoicesContainer_invoices$ref,
|};
export type InvoicesQuery = {|
  variables: InvoicesQueryVariables,
  response: InvoicesQueryResponse,
|};
*/


/*
query InvoicesQuery(
  $search: String
  $sortBy: InvoiceSort
  $statuses: [InvoiceStatus!]
  $customerIds: [ID!]
  $orderIds: [ID!]
  $issueDateStart: Date
  $issueDateEnd: Date
  $dueDateStart: Date
  $dueDateEnd: Date
) {
  ...PaginatedInvoicesContainer_invoices_39DYH0
  viewer {
    id
    permissions
    company {
      id
    }
  }
}

fragment PaginatedInvoicesContainer_invoices_39DYH0 on Query {
  invoices(first: 30, search: $search, sortBy: $sortBy, statuses: $statuses, customerIds: $customerIds, orderIds: $orderIds, issueDateStart: $issueDateStart, issueDateEnd: $issueDateEnd, dueDateStart: $dueDateStart, dueDateEnd: $dueDateEnd) {
    edges {
      cursor
      ...InvoicesTable_invoiceEdges
      node {
        __typename
        id
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment InvoicesTable_invoiceEdges on InvoiceEdge {
  node {
    id
    invoiceNumber
    status
    currency
    totalAmount
    amountDue
    issueDate
    dueDate
    notes
    order {
      id
      orderNumber
    }
    customer {
      id
      name
    }
    createdAt
    updatedAt
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "count",
    "type": "Int!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "cursor",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "search",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "sortBy",
    "type": "InvoiceSort",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "statuses",
    "type": "[InvoiceStatus!]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "customerIds",
    "type": "[ID!]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "orderIds",
    "type": "[ID!]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "issueDateStart",
    "type": "Date",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "issueDateEnd",
    "type": "Date",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "dueDateStart",
    "type": "Date",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "dueDateEnd",
    "type": "Date",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "viewer",
  "storageKey": null,
  "args": null,
  "concreteType": "User",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "permissions",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "company",
      "storageKey": null,
      "args": null,
      "concreteType": "Company",
      "plural": false,
      "selections": [
        (v1/*: any*/)
      ]
    }
  ]
},
v3 = {
  "kind": "Variable",
  "name": "customerIds",
  "variableName": "customerIds"
},
v4 = {
  "kind": "Variable",
  "name": "dueDateEnd",
  "variableName": "dueDateEnd"
},
v5 = {
  "kind": "Variable",
  "name": "dueDateStart",
  "variableName": "dueDateStart"
},
v6 = {
  "kind": "Variable",
  "name": "issueDateEnd",
  "variableName": "issueDateEnd"
},
v7 = {
  "kind": "Variable",
  "name": "issueDateStart",
  "variableName": "issueDateStart"
},
v8 = {
  "kind": "Variable",
  "name": "orderIds",
  "variableName": "orderIds"
},
v9 = {
  "kind": "Variable",
  "name": "search",
  "variableName": "search"
},
v10 = {
  "kind": "Variable",
  "name": "sortBy",
  "variableName": "sortBy"
},
v11 = {
  "kind": "Variable",
  "name": "statuses",
  "variableName": "statuses"
},
v12 = [
  (v3/*: any*/),
  (v4/*: any*/),
  (v5/*: any*/),
  {
    "kind": "Literal",
    "name": "first",
    "value": 30
  },
  (v6/*: any*/),
  (v7/*: any*/),
  (v8/*: any*/),
  (v9/*: any*/),
  (v10/*: any*/),
  (v11/*: any*/)
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "InvoicesQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      (v2/*: any*/),
      {
        "kind": "FragmentSpread",
        "name": "PaginatedInvoicesContainer_invoices",
        "args": [
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/)
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "InvoicesQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "invoices",
        "storageKey": null,
        "args": (v12/*: any*/),
        "concreteType": "InvoiceConnection",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "InvoiceEdge",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "cursor",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Invoice",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "invoiceNumber",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "status",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "currency",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "totalAmount",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "amountDue",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "issueDate",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "dueDate",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "notes",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "order",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Order",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "orderNumber",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "customer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Customer",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "name",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "createdAt",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "updatedAt",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "__typename",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "pageInfo",
            "storageKey": null,
            "args": null,
            "concreteType": "PageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "endCursor",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "hasNextPage",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      },
      {
        "kind": "LinkedHandle",
        "alias": null,
        "name": "invoices",
        "args": (v12/*: any*/),
        "handle": "connection",
        "key": "PaginatedInvoicesContainer_invoices",
        "filters": []
      },
      (v2/*: any*/)
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "InvoicesQuery",
    "id": null,
    "text": "query InvoicesQuery(\n  $search: String\n  $sortBy: InvoiceSort\n  $statuses: [InvoiceStatus!]\n  $customerIds: [ID!]\n  $orderIds: [ID!]\n  $issueDateStart: Date\n  $issueDateEnd: Date\n  $dueDateStart: Date\n  $dueDateEnd: Date\n) {\n  ...PaginatedInvoicesContainer_invoices_39DYH0\n  viewer {\n    id\n    permissions\n    company {\n      id\n    }\n  }\n}\n\nfragment PaginatedInvoicesContainer_invoices_39DYH0 on Query {\n  invoices(first: 30, search: $search, sortBy: $sortBy, statuses: $statuses, customerIds: $customerIds, orderIds: $orderIds, issueDateStart: $issueDateStart, issueDateEnd: $issueDateEnd, dueDateStart: $dueDateStart, dueDateEnd: $dueDateEnd) {\n    edges {\n      cursor\n      ...InvoicesTable_invoiceEdges\n      node {\n        __typename\n        id\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment InvoicesTable_invoiceEdges on InvoiceEdge {\n  node {\n    id\n    invoiceNumber\n    status\n    currency\n    totalAmount\n    amountDue\n    issueDate\n    dueDate\n    notes\n    order {\n      id\n      orderNumber\n    }\n    customer {\n      id\n      name\n    }\n    createdAt\n    updatedAt\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'cfa164c55c62cef39da50ae68d09a2e3';
module.exports = node;
